<template>
  <section class="bg_color">
    <h2>過去のオーナーランキング</h2>
    <section class="inner">
      <!--owner-->
      <div>
        <div class="box_lst rank last_year">
          <h4 class="ttl_lst">
            <p class="inner crown">
              2025/26 総合<span class="invisible_sp">&nbsp;</span
              ><br class="hidden-md" />オーナーランキング
            </p>
          </h4>
          <ul class="lst">
            <li class="first">
              <p class="ribon_rank first">1<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico01.svg" alt="" />
                </figure>
                <p class="name">ゆう</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">104,326,000</p>
              </div>
            </li>
            <li class="second">
              <p class="ribon_rank first">2<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico03.svg" alt="" />
                </figure>
                <p class="name">こばゃま</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">102,672,000</p>
              </div>
            </li>
            <li class="third">
              <p class="ribon_rank first">3<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico16.svg" alt="" />
                </figure>
                <p class="name">サルマサ</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">100,377,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">4<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico05.svg" alt="" />
                </figure>
                <p class="name">かぴ</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">100,349,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">5<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico04.svg" alt="" />
                </figure>
                <p class="name">ブルーモンキー</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">100,033,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">6<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico04.svg" alt="" />
                </figure>
                <p class="name">43ケン</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">99,159,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">7<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico01.svg" alt="" />
                </figure>
                <p class="name">じろう</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">98,930,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">8<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico01.svg" alt="" />
                </figure>
                <p class="name">へいよー</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">98,661,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">9<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico08.svg" alt="" />
                </figure>
                <p class="name">山口田口山田</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">98,447,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">10<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico02.svg" alt="" />
                </figure>
                <p class="name">ゆら</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">98,306,000</p>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div>
        <div class="box_lst rank last_year">
          <h4 class="ttl_lst">
            <p class="inner crown">
              2025/26 2nd TURN<span class="invisible_sp">&nbsp;</span
              ><br class="hidden-md" />オーナーランキング
            </p>
          </h4>
          <ul class="lst">
            <li class="first">
              <p class="ribon_rank first">1<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico05.svg" alt="" />
                </figure>
                <p class="name">ルーキー理論</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">56,642,000</p>
              </div>
            </li>
            <li class="second">
              <p class="ribon_rank first">2<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico03.svg" alt="" />
                </figure>
                <p class="name">あき007</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">56,164,000</p>
              </div>
            </li>
            <li class="third">
              <p class="ribon_rank first">3<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico15.svg" alt="" />
                </figure>
                <p class="name">ぜんぞー</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">55,181,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">4<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico04.svg" alt="" />
                </figure>
                <p class="name">大マル頑張れ</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">55,064,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">5<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico08.svg" alt="" />
                </figure>
                <p class="name">ちゃぼ</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">54,983,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">6<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico03.svg" alt="" />
                </figure>
                <p class="name">きのぴ</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">54,937,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">7<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico01.svg" alt="" />
                </figure>
                <p class="name">ゆう</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">54,613,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">8<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico04.svg" alt="" />
                </figure>
                <p class="name">幸仁</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">54,457,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">9<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico03.svg" alt="" />
                </figure>
                <p class="name">こばゃま</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">54,351,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">10<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico01.svg" alt="" />
                </figure>
                <p class="name">バスゴダガマ</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">53,805,000</p>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div>
        <div class="box_lst rank last_year">
          <h4 class="ttl_lst">
            <p class="inner crown">
              2025/26 1st TURN<span class="invisible_sp">&nbsp;</span
              ><br class="hidden-md" />オーナーランキング
            </p>
          </h4>
          <ul class="lst">
            <li class="first">
              <p class="ribon_rank first">1<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico05.svg" alt="" />
                </figure>
                <p class="name">かぴ</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">51,268,000</p>
              </div>
            </li>
            <li class="second">
              <p class="ribon_rank first">2<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico04.svg" alt="" />
                </figure>
                <p class="name">ブルーモンキー</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">49,807,000</p>
              </div>
            </li>
            <li class="third">
              <p class="ribon_rank first">3<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico01.svg" alt="" />
                </figure>
                <p class="name">ゆう</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">49,713,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">4<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico01.svg" alt="" />
                </figure>
                <p class="name">まさとっこ</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">49,460,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">5<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico02.svg" alt="" />
                </figure>
                <p class="name">諸積ゲンズブール</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">49,100,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">6<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico04.svg" alt="" />
                </figure>
                <p class="name">のっけ</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">49,000,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">7<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico15.svg" alt="" />
                </figure>
                <p class="name">真君</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">48,961,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">8<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico01.svg" alt="" />
                </figure>
                <p class="name">Mr.ノーマネー</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">48,815,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">9<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico05.svg" alt="" />
                </figure>
                <p class="name">あつぽん</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">48,672,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">10<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico01.svg" alt="" />
                </figure>
                <p class="name">ひろ99</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">48,634,000</p>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div>
        <div class="box_lst rank last_year">
          <h4 class="ttl_lst">
            <p class="inner crown">
              2024/25season<span class="invisible_sp">&nbsp;</span
              ><br class="hidden-md" />オーナーランキング
            </p>
          </h4>
          <ul class="lst">
            <li class="first">
              <p class="ribon_rank first">1<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico03.svg" alt="" />
                </figure>
                <p class="name">カズサイキョウ</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">108,509,000</p>
              </div>
            </li>
            <li class="second">
              <p class="ribon_rank first">2<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico04.svg" alt="" />
                </figure>
                <p class="name">リュウサソ</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">108,247,000</p>
              </div>
            </li>
            <li class="third">
              <p class="ribon_rank first">3<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico12.svg" alt="" />
                </figure>
                <p class="name">とことこトコタン</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">107,322,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">4<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico02.svg" alt="" />
                </figure>
                <p class="name">ゆめ</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">106,950,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">5<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico14.svg" alt="" />
                </figure>
                <p class="name">まめ</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">106,854,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">6<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico04.svg" alt="" />
                </figure>
                <p class="name">ドラポート</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">106,584,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">7<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico03.svg" alt="" />
                </figure>
                <p class="name">ぷこ</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">106,323,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">8<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico04.svg" alt="" />
                </figure>
                <p class="name">43ケン</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">105,670,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">9<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico06.svg" alt="" />
                </figure>
                <p class="name">あっちゃん7</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">105,326,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">10<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico01.svg" alt="" />
                </figure>
                <p class="name">テトラ</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">105,291,000</p>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div>
        <div class="box_lst rank last_year">
          <h4 class="ttl_lst">
            <p class="inner crown">
              2023/24season<span class="invisible_sp">&nbsp;</span
              ><br class="hidden-md" />オーナーランキング
            </p>
          </h4>
          <ul class="lst">
            <li class="first">
              <p class="ribon_rank first">1<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico03.svg" alt="" />
                </figure>
                <p class="name">末吉大吉</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">96,393,000</p>
              </div>
            </li>
            <li class="second">
              <p class="ribon_rank first">2<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico01.svg" alt="" />
                </figure>
                <p class="name">山</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">94,734,000</p>
              </div>
            </li>
            <li class="third">
              <p class="ribon_rank first">3<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico05.svg" alt="" />
                </figure>
                <p class="name">すけのすけ</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">94,364,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">4<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico05.svg" alt="" />
                </figure>
                <p class="name">社会人</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">94,127,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">5<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico15.svg" alt="" />
                </figure>
                <p class="name">しん</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">94,060,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">6<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico06.svg" alt="" />
                </figure>
                <p class="name">なっつみー</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">94,029,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">7<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico01.svg" alt="" />
                </figure>
                <p class="name">ハチ</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">94,000,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">8<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico04.svg" alt="" />
                </figure>
                <p class="name">ハル456</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">93,906,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">9<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico01.svg" alt="" />
                </figure>
                <p class="name">ルシファー</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">93,653,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">10<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico01.svg" alt="" />
                </figure>
                <p class="name">59ファイター</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">93,583,000</p>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div>
        <div class="box_lst rank last_year">
          <h4 class="ttl_lst">
            <p class="inner crown">
              2022/23season<span class="invisible_sp">&nbsp;</span
              ><br class="hidden-md" />オーナーランキング
            </p>
          </h4>
          <ul class="lst">
            <li class="first">
              <p class="ribon_rank first">1<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico01.svg" alt="" />
                </figure>
                <p class="name">まっし</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">77,660,000</p>
              </div>
            </li>
            <li class="second">
              <p class="ribon_rank first">2<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico18.svg" alt="" />
                </figure>
                <p class="name">パパリンコ</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">77,456,000</p>
              </div>
            </li>
            <li class="third">
              <p class="ribon_rank first">3<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico02.svg" alt="" />
                </figure>
                <p class="name">けんた</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">76,717,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">4<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico01.svg" alt="" />
                </figure>
                <p class="name">かとりょう</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">75,744,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">5<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico05.svg" alt="" />
                </figure>
                <p class="name">山崎智也の影</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">75,682,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">6<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico01.svg" alt="" />
                </figure>
                <p class="name">なじわら</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">74,126,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">7<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico02.svg" alt="" />
                </figure>
                <p class="name">ベック</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">74,101,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">8<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico03.svg" alt="" />
                </figure>
                <p class="name">かばっち</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">73,198,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">9<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico03.svg" alt="" />
                </figure>
                <p class="name">ふかひで</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">73,197,000</p>
              </div>
            </li>
            <li>
              <p class="ribon_rank first">10<span class="small">位</span></p>
              <div class="box_thum">
                <figure>
                  <img src="@/assets/images/parts/ico14.svg" alt="" />
                </figure>
                <p class="name">アゴマスク</p>
              </div>
              <div class="box_dtl">
                <p class="ttl">総獲得モグー</p>
                <p class="txt point">73,113,000</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import Mixin from "@/mixins/mixin";
import { mapGetters } from "vuex";

export default {
  name: "RankingLastYear",
  mixins: [Mixin],
  beforeMount: function () {
    this.$store.dispatch("rankingOwnerInfo");
  },
  mounted: function () {
    this.$setInterval(() => {
      this.$store.dispatch("rankingOwnerInfo");
    }, 15000);
  },
  computed: {
    ...mapGetters({
      info: "getRankingOwnerInfo",
      Icon: "getIcon",
    }),
  },
  beforeUnmount: function () {
    this.$clearAllIntervals();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css" src="@/assets/css/style_parts.css" scoped></style>
<style lang="css" src="@/assets/css/style_ranking_last_year.css" scoped></style>
